export default "__VITE_ASSET__fdcbbc89__"